import generalInformations from './generalInformations'
import openQuestions from './openQuestions'

const pages = {
  generalInformations,
  openQuestions,
}

export default pages
